export default "__VITE_ASSET__CbJklGA2__"